import { useEffect } from 'react';
import { node } from 'prop-types';
import { CardContent } from '@material-ui/core';

import { Logo } from 'components';
import { getSettings } from 'utils/settings';

import { HEADERS } from './constants';
import useStyles from './styles';
import Footer from './Footer';
import PoweredImage from '../../assets/images/powered-img.png';

function AutheticationLayout({ children }) {
  const { location } = window;
  const classes = useStyles();
  const site = getSettings('site', {});

  const updatePageInfo = function () {
    const header = HEADERS.find(({ pathname }) => pathname === location.pathname);

    document.title = `${header?.title} | ${site?.title || 'Blokfon'}`;
    if (site?.favicon) {
      document.querySelector('link[rel="icon"]').href = site.favicon;
    }
  };

  useEffect(() => {
    updatePageInfo();
  }, [window.location.hash, window.location.pathname]);

  return (
    <div className={classes.root}>
      <header className={classes.layoutHeader}>
        <Logo maxHeight={48} type="light" />
      </header>

      <div className={classes.noPadding} maxWidth="lg">
        <CardContent
          children={children}
          className={[classes.content_2, classes.contentFormv2]}
        />
        <Footer />
        <img src={PoweredImage} alt='Powered by DynamiCore' className={classes.poweredImage} />
      </div>
    </div>
  );
};

AutheticationLayout.propTypes = {
  children: node,
};

export default AutheticationLayout;
